import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { UserService } from 'src/app/service/user.service';
import { Router } from '@angular/router';
import { FormHelper } from 'src/app/util/formHelper';
import { Log } from '../../util/log';
import { ControlUserInstallation } from 'src/app/model/controlUserInstallation';
import { v4 as uuid } from 'uuid';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {

  @ViewChild('registerloader', { static: true }) loader;

  emailInvalid: boolean;
  passwordInvalid: boolean;
  passwordMismatch: boolean;
  userAlreadyRegistered: boolean;
  privacyNotAccepted: boolean;
  termsNotAccepted: boolean;

  terms: boolean;
  privacy: boolean;
  marketing: boolean;

  constructor(private userService: UserService, private router: Router, private cdRef:ChangeDetectorRef) { }

  ngOnInit() {
  }

  onPrivacyChanged(event: any) {

    this.privacy = event.target.checked;
  }

  onTermsChanged(event: any) {

    this.terms = event.target.checked;
  }

  onMarketingChanged(event: any) {

    this.marketing = event.target.checked;
  }

  register(email: string, password: string, password2: string) {

    this.emailInvalid = false;
    this.passwordInvalid = false;
    this.passwordMismatch = false;
    this.userAlreadyRegistered = false;
    this.privacyNotAccepted = false;
    this.termsNotAccepted = false;

    if (!FormHelper.isValidEmail(email)) {
      this.emailInvalid = true;
      return;
    }
    if (!FormHelper.isValidPassword(password)) {
      this.passwordInvalid = true;
      return;
    }
    if (password != password2) {
      Log.debug("passwords do not match");
      this.passwordMismatch = true;
      return;
    }
    if (!this.privacy) {
      Log.debug("privacy not accepted");
      this.privacyNotAccepted = true;
      return;
    }
    if (!this.terms) {
      Log.debug("terms not accepted");
      this.termsNotAccepted = true;
      return;
    }

    this.loader.showLoading();
    this.loader.hideError();

    this.userService.register(email, password).then((user) => {

      Log.debug("firebase user: " + JSON.stringify(user));

      this.createUser(email, false);

    }).catch((error) => {

      Log.debug("error: " + JSON.stringify(error));

      // "code":"auth/email-already-in-use"

      if (error.code == "auth/email-already-in-use") {

        this.userService.login(email, password).then((user) => {

          Log.debug("user: " + JSON.stringify(user));

          this.createUser(email, true);

        }).catch((error) => {

          this.loader.hideLoading();

          this.userAlreadyRegistered = true;
          this.cdRef.detectChanges();
        });
      }
      else {

        this.loader.hideLoading();

        this.loader.showError();
        this.cdRef.detectChanges();
      }
    });
  }

  createUser(email: string, alreadyRegistered: boolean) {

    this.userService.createUser(email).subscribe(user => {

      Log.debug("user: " + JSON.stringify(user));

      this.createInstallation(user.uid, alreadyRegistered);

    }, errorRes => {

      Log.debug("errorRes: " + JSON.stringify(errorRes));

      this.loader.hideLoading();
      this.loader.showError();
    });
  }

  createInstallation(userUid: string, alreadyRegistered: boolean) {

    let installation = new ControlUserInstallation();
    installation.deviceUid = uuid();
    installation.userUid = userUid;

    this.userService.createUserInstallation(installation).subscribe(() => {
       
      this.loader.hideLoading();

      // TODO capire se ok
      this.router.navigate(['dashboard']);

    }, errorRes => {

      Log.debug("errorRes: " + JSON.stringify(errorRes));

      this.loader.hideLoading();
      this.loader.showError();
    });
  }

}
